
    <fieldmagic-dialog
      [label]="'History (%s)' | translate | sprintf: [(loggedAt$ | async | format: 'lll')]"
      icon="history"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
          <fieldmagic-primary-button
            label="Restore"
            icon="history"
            (click)="onRestore()"
            [disabled]="(fetching$ | async) || (restoring$ | async)"
          >
          </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <fieldmagic-async-content
          [loading]="fetching$ | async"
        >
          <ng-template
            fieldmagicAsyncLoadedContent
          >
            <app-viewform
              [objRecordDetails]="details"
              [isHistory]="true"
            ></app-viewform>
          </ng-template>
        </fieldmagic-async-content>
      </ng-template>
    </fieldmagic-dialog>
  